module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/electricity-4.webp";